export default {"src":"/_next/static/media/country-icon.e5b76b77.svg","height":14,"width":17};